import { render } from "./OptionsMenu.vue?vue&type=template&id=623f7fba&scoped=true"
import script from "./OptionsMenu.vue?vue&type=script&lang=js"
export * from "./OptionsMenu.vue?vue&type=script&lang=js"

import "./OptionsMenu.vue?vue&type=style&index=0&id=623f7fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623f7fba"]])

export default __exports__